import { render, staticRenderFns } from "./item2.vue?vue&type=template&id=04462f7b&scoped=true"
import script from "./item2.vue?vue&type=script&lang=js"
export * from "./item2.vue?vue&type=script&lang=js"
import style0 from "./item2.vue?vue&type=style&index=0&id=04462f7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04462f7b",
  null
  
)

export default component.exports